import React from 'react'
import Img from '../../assets/Images/ValueImage.png'
import Img1 from '../../assets/Images/user-rectangle.svg'
import Img2 from '../../assets/Images/Vector.png'
import styled from 'styled-components'




const P = styled.p`
color: #202939;
margin-bottom: 5px;
font-size: 30px;
font-weight: 700;
.color-para{
    color: #3545EE;
}
`
const P1 = styled.p`
margin-bottom: 5px;
margin-top: 7px;
font-size: 20px;
font-weight: 600;
`
const Button = styled.button`
border-radius: 20px;
border: none;
background: none;
color: #3545EE;
font-size: 15px;
font-weight: 600;
`
const Para = styled.p`
font-size: 16px;
text-align: justify;
`



function Value() {
  return (
    <div className='container bg-white'>
        <div className='row m-0 pt-5 pb-2 d-flex justify-content-center  align-items-center'>
            <div className='col-md-6'>
                <Button>Values</Button>
                <P>Putting <span className='color-para'>Our Users First</span></P>
                <Para>Users come first at Qvani. Protecting you and your data has been our priority since day one. That’s why we’ve built the Qvani platform with advanced security measures and robust data privacy controls at every level.</Para>
                <div className='d-flex flex-md-nowrap flex-wrap gap-3 pt-4'>
                    <div className='text-start px-2'>
                        <img src={Img1} alt='--'/>  
                        <P1>Accountability</P1>  
                        <Para>We are deeply accountable to our customers, and this means staying connected with them at all times. By fostering ongoing communication, we collaborate effectively to nurture and build a thriving, supportive community.</Para>
                    </div>
                    <div className='text-start px-2'>
                        <img src={Img2} alt='--'/>  
                        <P1>Passion</P1>    
                        <Para>Qvani is building a community-driven platform where everyone's voice is heard, and everyone benefits. Built for the people, by the people, Qvani is where growth meets collaboration.</Para>
                    </div>
                </div>
            </div>
            <div className='d-none d-md-block col-md-6'>
                <img src={Img} width={'100%'} />
            </div>
        </div> 
    </div>
  )
}

export default Value